/**
 * CommonSelect - Web端选择器组件
 *
 * @features
 * - 基于Ant Design Select实现
 * - 支持禁用状态
 *
 * @usage
 * ```tsx
 * <CommonSelect
 *   defaultValue="option1"
 *   placeholder="请选择选项"
 *   options={[{value: 'option1', title: '选项1'}]}
 *   onSelect={(value) => console.log(value)}
 * />
 * ```
 */

import React from "react";
import { Select } from "antd";
import { i18nCrossUtil } from "@adgm/libs";
import type { IOptionItem, TCommonSelectWebProps } from "@adgm/cross-models";
import { colors, fontSize } from "../../styles/common";
import styles from "@aspen/theme/Profile.module.less";
import "antd/es/select/style/index.less";

const { Option } = Select;

/**
 * Web端选择器组件
 */
export const CommonSelect: React.FC<TCommonSelectWebProps> = ({
  value,
  onSelect,
  placeholder,
  options = [],
  disabled = false,
  allowClear = true,
  filterOption,
  showSearch,
  multiple,
  className,
  style: propsStyle,
}) => {
  const crossIntl = i18nCrossUtil.t();
  const defaultPlaceholder = placeholder || crossIntl["kyc.please.select"];
  const handleChange = (selectedValue: string, option: IOptionItem) => {
    onSelect?.(selectedValue, option);
  };

  return (
    <>
      <style>{`
        .ant-radio-checked .ant-radio-inner {
          background-color: var(--main-color) !important;
          border-color: var(--main-color) !important;
        }
      `}</style>
      <Select
        className={styles[className] || styles.commonSelect}
        mode={multiple ? "multiple" : undefined}
        value={value}
        style={{
          flex: 1,
          fontSize: fontSize.f14,
          fontFamily: "Common-Regular",
          height: 46,
          ...propsStyle,
        }}
        placeholder={defaultPlaceholder}
        disabled={disabled}
        allowClear={allowClear}
        showSearch={showSearch}
        optionFilterProp="label"
        filterOption={filterOption}
        onChange={handleChange}
        size="large">
        {options.map(option => (
          <Option key={option.value} value={option.value} label={option.title}>
            <span
              style={{
                color: colors.white16,
                fontSize: fontSize.f14,
                fontFamily: "Common-Regular",
                overflow: "visible",
                whiteSpace: "normal",
              }}>
              {option.title}
            </span>
          </Option>
        ))}
      </Select>
    </>
  );
};
